<template>
    <div class="ranking-desktop desktop-only">
        <h3>Top Qualified</h3>
        <div class="ranking-desktop--tabs">
            <div v-for="(value, index) in ranking"
                 :key="index"
                 :class="{ 'active' : value.code === selected }"
                 @click="setRanking(value.code)"
                 class="ranking-desktop--tab">
                    <p>{{ value.name }}</p>
            </div>
        </div>
        <div class="ranking-desktop--header">
            <img src="/static/img/coins/bronze-big.png" class="coin-bg">
            <img :src="getCoinPath(selected)" class="coin-icon">
            <p>See below people qualified as {{ ranking[selected].name }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['ranking', 'selected', 'setRanking'],
        methods: {
            getCoinPath: function(code) {
                return 'static/img/coins/' + code + '.png';
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../assets/scss/_colors.scss';

    .ranking-desktop--tabs{
        display: flex;
        justify-content: space-between;
        margin: 24px 0 0;
        border: 3px solid $base1;

    }

    .ranking-desktop--tab{
        background: $white;
        padding: 16px 24px;
        width: 100%;
        white-space: nowrap;
        transition: 200ms all linear;
        cursor: pointer;

        &:not(:last-child){
            border-right: 1px solid $base1;
        }

        @media(max-width: 1150px){
            padding: 16px;
        }

        p{
            color: $base1;
            transition: 200ms all linear;

            @media(max-width: 1150px){
                font-size: 13px;
            }
        }

        &.active,
        &:hover{
            background-color: $base1;

            p{
                color: $white;
            }
        }
    }

    .ranking-desktop--header{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 3px solid $base1;
        background: $base1;
        padding: 22px 40px;
        overflow: hidden;

        p{
            position: relative;
            z-index: 2;
            font-size: 18px;
            color: $white;
        }

        .coin-icon{
            position: relative;
            z-index: 2;
            width: 120px;
        }

        .coin-bg{
            position: absolute;
            left: -181px;
            top: -199px;
            width: 558px;
            opacity: 0.2;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/top-qualified/TabsDesktop.vue